<aur-mat-table
  [tableData]="tableData"
  [tableConfig]="tableConfig"
  (rowClick)="onClick($event)"
  (rowAction)="onAction($event)"
></aur-mat-table>
